<div class="welcome">
    <img src="assets/initial-form/welcome.png" alt="Bienvenido" class="welcome__image" />

    <p class="welcome__phrase">
        Descubre y potencia tus competencias, habilidades y talentos, para lograr una exitosa
        admisión universitaria y desarrollar desde ya, un perfil profesional óptimo.
    </p>

</div>